import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserauthenticationserviceService } from './userauthenticationservice.service';
import { ExamService } from './exam.service';
import { LanguageService } from './language.service';
import { Subject } from 'rxjs';
import { CandidateComplaint } from '../models/model';
@Injectable({
  providedIn: 'root'
})
export class ProctoringService {

  promises = new Map<number, any>();
  confirmproctoringinterval;
  chatopened = false;
  proctorAssigned = false;
  private isProctoringIframeResult: boolean | null = null;
  private isProctoringIframePromise: Promise<boolean> | null = null;
  examScheduleID: number;
  notPublishingTimes = 0;
  pauseStatus: { proctorpaused: boolean; adminpaused: boolean; pausereason: string; } = { proctorpaused: false, adminpaused: false, pausereason: '' };
  username: string;
  pauseStatusUpdated: Subject<{ pause: string, reason: string }> = new Subject<{ pause: string, reason: string }>();
  //published = false;
  constructor(private toastr: ToastrService, private router: Router, private userauthservice: UserauthenticationserviceService, private examService: ExamService, private languageService: LanguageService) {
    //questionservice needs this service creating a circular dependncy
    //this can be looked into later, but right now there's not time
    //so we'll just set it
    this.examService.questionservice.proctoringService = this;
    window.addEventListener('message', this.proctorMessageListener.bind(this));
  }
  get language() {
    return this.languageService.language;
  }
  proctorMessageListener(evt) {
    //console.log(evt.data);
    // if (evt.data.status === 'published') {
    //     console.log('published');
    //     console.log(evt.data);
    //     this.published = true;
    //     //window.removeEventListener('message', messagelistener);
    // }
    // else if(evt.data.status === 'notpublishing') {
    //   this.published = false;
    // }
    if (evt.data.messageid) {
      if (this.promises.has(evt.data.messageid)) {
        const fns = this.promises.get(evt.data.messageid);
        const acceptfn = fns[0];
        const rejectfn = fns[1];
        this.promises.delete(evt.data.messageid);

        if (evt.data.success) {
          acceptfn(evt.data);
        }
        else {
          rejectfn(evt.data);
        }
      }
    }
    else if (evt.data.event) {
      switch (evt.data.event) {
        case 'chatopened':
          this.chatopened = true;
          break;
        case 'chatclosed':
          this.chatopened = false;
          break;
        case 'enteredroom':
          this.proctorAssigned = true;
          this.setProctorPauseStatus();
          break;
        case 'leftroom':
          this.proctorAssigned = false;
          break;
        case 'onNoFace':
        case 'onFaceChange':
        case 'onMultipleFaces':
        case 'onCandidateFaceMatchChange':
        case 'onLowLight':
        case 'onHighIntensityLight':
        case 'onNoise':
          //console.log(evt.data.warning);
          //console.log("event overide ai" + evt.data.overrideai);
          if (!evt.data.overrideai)
            this.toastr.warning(evt.data.warning, undefined, { timeOut: 10000 });//show toastr for 10 seconds
          break;
        case 'aipenalty':
          this.toastr.error(evt.data.message, undefined, { timeOut: 10000 });//show toastr for 10 seconds
          break;
        case 'pauseStatusChanged'://changed by proctor
          const { pause, reason, proctorfullname } = evt.data;
          this.pauseStatus = { proctorpaused: pause, adminpaused: this.pauseStatus?.adminpaused ?? false, pausereason: reason };
          this.pauseStatusUpdated.next({ pause, reason });
          break;
        case 'getPauseStatus':
          this.setProctorPauseStatus();
          break;
        default:
          break;
      }
    }
  }



  //this should only be called when the user clicks the start button
  async startProctor(username, name, examid, examdesc, examscheduleid, attempt, passportversion, passporttype, skipAIPassportCheck, skipAIVideoFeedCheck, allowExternalPrimaryWebcam, allowExternalSecondViewWebcam, secondViewRequired, lockCandidatesToProctor) {
    this.examScheduleID = examscheduleid;
    this.username = username;
    //console.log("examschedule id is " + examscheduleid)
    let overrideSchedulePreventExamStart;
    overrideSchedulePreventExamStart = await this.examService.overrideScheduleAIPreventExamStart(this.examScheduleID, examid);
    //console.log("overrideai is " + !overrideSchedulePreventExamStart.msg);

    skipAIPassportCheck = skipAIPassportCheck || overrideSchedulePreventExamStart.msg;

    const primaryViewStartPromise = this.sendMessage({
      operation: 'start',
      username: username,
      name: name + ` (${examdesc})`,
      examid: examid,
      examdesc: examdesc,
      attempt: attempt,
      //overrideai: !overrideSchedulePreventExamStart.msg,
      passportversion: passportversion,
      passporttype: passporttype,
      aiCheckPhotoBeforeStart: passportversion > 0 && !skipAIPassportCheck,
      skipAIVideoFeedCheck: skipAIVideoFeedCheck,
      scheduleid: examscheduleid,
      allowExternalPrimaryWebcam: allowExternalPrimaryWebcam,
      allowExternalSecondViewWebcam: allowExternalSecondViewWebcam,
      secondViewRequired: secondViewRequired,
      startSecondViewProctor: secondViewRequired,
      lockCandidatesToProctor: lockCandidatesToProctor,
    });

    //const timeoutPromise = new Promise((res) => setTimeout(() => res("timeout"), 2 * 60 * 1000));//2 minute timeout

    //const raceResult = await Promise.race([startPromise, timeoutPromise]);

    // if(raceResult === "timeout"){
    //   throw "Unable to start proctor. Please check your internet connection and ensure you are using a supported browser.";
    // }

    const result = await primaryViewStartPromise as any;
    if (result.message === 'aipreventstart') {
        this.toastr.error(`${this.language.youhavebeenpreventedfromstarting}: ${result.reasons.join(',')}. ${this.language.tryCleaningTheCameraLensAndMovingCloserToTheScreen}`, undefined, { timeOut: 15000 });
        //if (result.reasons.includes('Candidate face mismatch detected')) {
        
        if(!skipAIPassportCheck){
          this.examService.logFaceMismatchActivity(examscheduleid, examid, username);//no need to wait for this
        }
        //}
        await this.stopProctor('AI Prevented Starting');
        const errorAny: any =  new Error("Exam access prevented by facial recognition engine");
        errorAny._doNotShow = true;
        throw errorAny;
    }
    else{
      //if the user has kept trying and has been able to start the exam, no need to do anything
      //so we can delete the face mismatch activity log
      this.examService.closeFaceMismatchActivityLog(examscheduleid, examid, username);//no need to wait for this
    }

    const createConfirmProctoringInterval = () => {
      this.confirmproctoringinterval = setInterval(async () => {
        //debugger;
        //ever 5 seconds, check if we're not publishing
        //whenever we find we're not publishing, wait another 25 seconds...if its still not publishing, then leave the exam page
        //that's 30 seconds total
        if (!await this.checkPublishing()) {
          this.notPublishingTimes++;
          if (this.notPublishingTimes >= 12) {//if not proctoring for a minute
            clearInterval(this.confirmproctoringinterval);
            this.notPublishingTimes = 0;
            if (!this.userauthservice.loggedOut) {
              this.toastr.error(this.language.connectiontomediaserverlost);
            }
            // if(!environment.production){
            //   debugger;
            //   console.trace('going to exams page');
            // }
            this.router.navigate(["/exam/userexams"]);
            this.stopProctor('Not Publishing');

          }
          // clearInterval(this.confirmproctoringinterval);
          // //this.router.navigate(["/exam/userexams"]);
          //debugger;
          // setTimeout(async () => {
          //   if (!await this.checkPublishing()) {
          //     //await this.proctorservice.startProctor(this.user.username, this.user.fullname, this.exam.examid, this.exam.examname);
          //     if (!this.userauthservice.loggedOut) {
          //       this.toastr.error('Connection to media server lost. Please reconnect');
          //     }
          //     await this.stopProctor();
          //     this.router.navigate(["/exam/userexams"]);
          //   }
          //   else {
          //     createConfirmProctoringInterval();
          //   }
          // }, 25000);
        }
        else {
          this.notPublishingTimes = 0;
        }
      }, 5000);//check every 5 seconds
    };

    createConfirmProctoringInterval();

    // return new Promise(function (accept: any, reject) {
    //     top.postMessage({ operation: 'start', username: username, name: name + ` (${examdesc})`, examid: examid, examdesc: examdesc, messageid: new Date().getTime() }, '*');//TODO: we have to add some authentication to make sure someone can't go straight to the actual exam url
    //     if(mythis.published){
    //       accept();
    //     }
    //     else{
    //       const checkPublishedInterval = setInterval(() => {
    //         if(mythis.published){
    //           clearInterval(checkPublishedInterval);
    //debugger;
    //           accept();
    //         }
    //       }, 50);
    //     }
    // });
  }

  async isProctoringIframe(): Promise<boolean> {
    if (self === top) {
      this.isProctoringIframeResult = false;
      return false;
    }
    if (this.isProctoringIframeResult !== null) {
      return this.isProctoringIframeResult;
    }
    if (this.isProctoringIframePromise) {
      return this.isProctoringIframePromise;
    }

    this.isProctoringIframePromise = this.sendMessage({ operation: 'ping' }, 1500)
      .then(() => {
        this.isProctoringIframeResult = true;
        return true;
      })
      .catch(() => {
        this.isProctoringIframeResult = false;
        return false;
      });

    return this.isProctoringIframePromise;
  }

  //this.published = false;
  async stopProctor(reason: string) {
    //top.postMessage({ operation: 'stop' }, '*');
    if (await this.isProctoringIframe()) {
      clearInterval(this.confirmproctoringinterval);
      // Do not await; required for reliable ending proctor session when running in a non proctor iframe.
      this.sendMessage({ operation: 'stop', reason: reason });
      this.proctorAssigned = false;//if we don't  do this, the request attention button will remain displayed when the user logs in again even when the proctee is not yet connected to a streaming server
    }
  }

  async showLoading() {
    //top.postMessage({ operation: 'loading', messageid: new Date().getTime()}, '*');
    await this.sendMessage({ operation: 'loading' });
  }

  async showLoaded() {
    //top.postMessage({ operation: 'loaded', messageid: new Date().getTime() }, '*');
    await this.sendMessage({ operation: 'loaded' });
  }

  async checkPublishing() {
    const res: any = await this.sendMessage({ operation: 'checkpublishing' });
    return res.publishing;
  }

  async getDualViewPreference(){
    const res: any = await this.sendMessage({ operation: 'getdualviewpreference' });
    return res.preference;
  }

  async setProctorPauseStatus() {
    await this.sendMessage({ operation: 'setproctorpausestatus', username: this.username, proctorpaused: this.pauseStatus.proctorpaused, adminpaused: this.pauseStatus.adminpaused, pausereason: this.pauseStatus.pausereason });
  }

  async setCountdownTimer(username, timeleft) {
    await this.sendMessage({ operation: 'setcountdowntimer', username: username, timeleft: timeleft });
  }

  async raiseHand(username) {
    await this.sendMessage({ operation: 'raisehand', username: username });
  }
  async quitSEB(username) {
    await this.sendMessage({ operation: 'quitseb', username: username });
  }
  // async hideSEBPowerButton(username) {
  //   await this.sendMessage({ operation: 'hidesebpb', username: username });
  // }
  async startProcteeTestVideo() {
    await this.sendMessage({ operation: 'procteetestvideo' });
  }
  // async getLastVideoChunkUploadedDetails() {
  //   return await this.sendMessage({ operation: 'getlastvideouploaddetails' });
  // }
  async getSebConfigKey(): Promise<string> {
    const res: any = await this.sendMessage({ operation: 'getsebkey' });
    return res.configKey;
  }

  sendMessage(message, timeoutMs?: number) {
    message.messageid = new Date().getTime();
    top.postMessage(message, '*');
    const mythis = this;
    return new Promise<any>(function (accept: any, reject: any) {
      mythis.promises.set(message.messageid, [accept, reject]);
      if (timeoutMs) {
        setTimeout(() => {
          if (mythis.promises.has(message.messageid)) {
            mythis.promises.delete(message.messageid);
            reject(new Error('timeout'));
          }
        }, timeoutMs);
      }
    });
  }
}
